import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigurationPageComponent } from '../pages/cms/configuration/configuration-page.component';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<ConfigurationPageComponent>
{
  canDeactivate(
    component: ConfigurationPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      component.hasConfigurationChanges(component.configurationForm),
      nextState.url,
      () => component.resetFormChanges(),
      () => component.save()
    );
  }
}
